export function lowercaseFirstLetter(string: string): string {
  if (!(typeof string === 'string') || string.length === 0) {
    return '';
  }
  return String(string).charAt(0).toLowerCase() + String(string).slice(1);
}

export function uppercaseFirstLetter(string: string): string {
  if (!(typeof string === 'string') || string.length === 0) {
    return '';
  }
  return String(string).charAt(0).toUpperCase() + String(string).slice(1);
}

export function naturalStringSort(a: string, b: string): number {
  return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
}
